/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOValidationData
 */
export interface TTLOValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TTLOValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TTLOValidationData
     */
    offsetDays?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TTLOValidationData
     */
    time?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TTLOValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof TTLOValidationData
     */
    readonly dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof TTLOValidationData
     */
    readonly travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof TTLOValidationData
     */
    readonly routes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof TTLOValidationData
     */
    readonly accountCodes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof TTLOValidationData
     */
    readonly bookingClasses?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TTLOValidationData
     */
    overrideDays?: ValidationMessage;
}

export function TTLOValidationDataFromJSON(json: any): TTLOValidationData {
    return TTLOValidationDataFromJSONTyped(json, false);
}

export function TTLOValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'offsetDays': !exists(json, 'offsetDays') ? undefined : ValidationMessageFromJSON(json['offsetDays']),
        'time': !exists(json, 'time') ? undefined : ValidationMessageFromJSON(json['time']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'overrideDays': !exists(json, 'overrideDays') ? undefined : ValidationMessageFromJSON(json['overrideDays']),
    };
}

export function TTLOValidationDataToJSON(value?: TTLOValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'offsetDays': ValidationMessageToJSON(value.offsetDays),
        'time': ValidationMessageToJSON(value.time),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
        'overrideDays': ValidationMessageToJSON(value.overrideDays),
    };
}


